function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13.92",
  viewBox: "0 0 15 13.92",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.17 5.61H3.7a4.8 4.8 0 00-3.56 1.4L0 7.17v4.58h2.26v-2.6l.3-.34.14-.16a6.1 6.1 0 012.61-1.6 3.65 3.65 0 01-1.13-1.44zM14.88 6.99a4.8 4.8 0 00-3.56-1.4 5.8 5.8 0 00-.6.03A3.65 3.65 0 019.62 7a6.04 6.04 0 012.76 1.66l.14.15.3.35v2.6H15v-4.6zM3.68 4.53h.17a3.57 3.57 0 011.72-3.48 2.27 2.27 0 10-1.9 3.5zM11.06 4.12a3.62 3.62 0 010 .38 2.27 2.27 0 00.32.03h.1A2.27 2.27 0 109.42 1.1a3.62 3.62 0 011.64 3.02zM9.9 4.12a2.48 2.48 0 11-2.47-2.47A2.48 2.48 0 019.9 4.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.56 7.92a5.37 5.37 0 00-3.94 1.5l-.14.15v3.5a.87.87 0 00.89.86h6.36a.87.87 0 00.89-.86v-3.5l-.13-.16a5.3 5.3 0 00-3.93-1.5z"
}))));